<script setup>
import { computed } from 'vue';
import Popper from 'vue3-popper';

const {
  colorScheme,
  placement,
  contentWidthClass,
  shouldUseCustomContentClass,
} = defineProps({
  colorScheme: {
    type: String,
    required: false,
    dafault: '',
  },
  placement: {
    type: String,
    required: false,
    default: 'top',
  },
  size: {
    type: String,
    required: false,
    default: 'md',
  },
  contentWidthClass: {
    type: String,
    required: false,
    default: 'w-32 text-center px-2 py-1 text-2xs',
  },
  shouldUseCustomContentClass: {
    type: Boolean,
    required: false,
    default: true,
  },
});
const iconColorClass = computed(() => {
  if (colorScheme == 'light') {
    return 'text-light-gray';
  } else if (colorScheme == 'orange') {
    return 'text-orange-500';
  } else {
    return 'text-dark-gray';
  }
});
const contentClass = computed(() =>
  shouldUseCustomContentClass
    ? colorScheme == 'light'
      ? 'bg-light-gray text-dark-gray'
      : 'bg-dark-gray text-light-gray'
    : ''
);
</script>

<template>
  <Popper
    :placement="placement"
    :hover="true"
    :arrow="true"
    offsetDistance="6"
  >
    <button
      class="group"
      :class="iconColorClass"
    >
      <slot name="icon"></slot>
    </button>
    <template #content>
      <div
        class="rounded-md"
        :class="[contentClass, contentWidthClass]"
      >
        <slot name="content"></slot>
      </div>
    </template>
  </Popper>
</template>

<style scoped>
:root {
  --popper-theme-background-color: #333333;
  --popper-theme-background-color-hover: #333333;
  --popper-theme-text-color: #ffffff;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 6px;
  --popper-theme-padding: 16px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}
</style>
